import { connect } from 'react-redux'

import PinkSlipAddressConfirmation from './PinkSlipAddressConfirmation'

import { sendPinkSlipAddress } from '../actions'

const mapDispatchToProps = {
  sendPinkSlipAddress,
}

const mapStateToProps = state => {
  return {
    address: state.mailPinkSlipReducer.pinkSlipAdress,
    submitting: state.mailPinkSlipReducer.submitting,
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PinkSlipAddressConfirmation)
